/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


 function showbtn() {
    var elements = document.getElementsByName("checkout-btn");
  for (var i = 0; i < elements.length; i++) {
   elements[i].style.display = "block";
  }
    var elements = document.getElementsByName("checkout-btn-disabled");
  for (var i = 0; i < elements.length; i++) {
   elements[i].style.display = "none";
  }
}

var url = location.href

if (url.includes('/apps/savedcart')){
  setTimeout(savedCartPrettify, 2500)
} else if (url.includes('/cart')){
  savedCartPrettify()
}

function savedCartPrettify(){
  var AOD_confirmBox = document.getElementById("aod_smart_cart_saver")

  var savedbtn = document.getElementsByClassName('btn')


  if (AOD_confirmBox){
    var container = AOD_confirmBox.children[0]
    container.classList.add('container')
    container.classList.add('container--medium')
    container.classList.add('container--flush')
  
    var heading = document.createElement('h2')
    heading.classList.add('heading')
    heading.classList.add('h2')
    heading.style.textAlign = 'center'
    heading.innerHTML = 'My Saved Carts'
    container.prepend(heading)
  
    var tableOverflow = container.children[1].children[1]
    tableOverflow.classList.add('overflow')
  
    var overflow = document.createElement('div')
    overflow.classList.add('overflow')
  
    var table = tableOverflow.children[2]
    table.classList.add('table')
    table.style.contentAlign = 'center'
  
    var thead = table.children[0]
    var tbody = table.children[1]
  
    var theadRow = thead.children
    var tbodyRow = tbody.children

    for (let i = 0; i < theadRow.length; i++){
      theadRow[i].style.textAlign = 'center'
    }
    for (let i = 0; i < tbodyRow.length; i++){
      tbodyRow[i].style.textAlign = 'center'
    }
  
    overflow.appendChild(table)
    tableOverflow.appendChild(overflow)
  } else if (savedbtn){
    for (let i = 0; i < savedbtn.length; i++){
      savedbtn[i].classList.add('button')
      savedbtn[i].classList.add('button--small')
    }
    savedbtn[0].classList.add('button--primary')
    savedbtn[1].classList.add('button--secondary')
  }
}